import { render } from "./CadastroListaServicosExtrasView.vue?vue&type=template&id=4c510eb8"
import script from "./CadastroListaServicosExtrasView.vue?vue&type=script&lang=js"
export * from "./CadastroListaServicosExtrasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__